import { orderOptionsAtom } from "core/shared/atoms";
import { OrderOptions, useSubmitProps } from "core/shared/types";
import { parseError } from "core/shared/utils";
import { action } from "framework/config/action";
import { URLS } from "framework/config/urls";
import { useEffect, useState } from "react";

export function useGetOrderOptions({ onSuccess, onError }: useSubmitProps) {
  const [loading, setLoading] = useState(false);
  const orderOptions = orderOptionsAtom.useValue();
  const submit = action(URLS.orderRequest);

  useEffect(() => {
    if (Object.keys(orderOptions).length) return;

    setLoading(true);
    submit({ action: "get-options" })
      .then((response) => {
        orderOptionsAtom.update(response.data as OrderOptions);
        onSuccess?.(response.data);
      })
      .catch((error) => {
        onError?.(parseError(error));
      })
      .finally(() => setLoading(false));
  }, []);

  return { orderOptions, loading };
}

export function useSubmitOrderRequest(
  type: string,
  { onSuccess, onError }: useSubmitProps,
) {
  const submit = action(URLS.orderRequest);

  const handleOrderRequest = async (values: any) => {
    const response = await submit({
      ...values,
      action: "create",
      type,
    });

    if (response.isOK) {
      onSuccess?.(response.data);
    } else {
      onError?.(parseError(response));
    }
  };

  return { handleOrderRequest };
}
